'use strict';

import CampaignSetting from './campaign-setting';
import Collection from './collection';

export default class CampaignSettingCollection extends Collection {
  constructor() {
    super(CampaignSetting);
  }
}
